/* eslint import/no-namespace:0 */
import React, { Component } from "react"
import { connect } from "react-redux"
import { reduxForm, propTypes, Field, getFormSyncErrors, change, formValueSelector } from 'redux-form'
import { bindActionCreators } from 'redux'
import { PropTypes } from 'prop-types'
import { Row, Col, FormGroup, Panel } from "react-bootstrap"
import moment from 'moment'
import { style } from '../../../utils/constants'
import { renderDatePickerField } from '../../../modules/components/datepickercomponent'
import { default as defaultformstate } from '../../../utils/statedefaultvalues/division'
import { addSeasonDivision, addingSeasonDivision } from "../../../redux/actions/seasonActions"
import {
  renderCheckboxField,
} from '../../../modules/components/checkboxfieldcomponent';
import * as styles from './Styles'
import ErrorList from './ErrorList'
import InfoSaved from './InfoSaved'


const formName = 'divisionsadd'

class DivisionsAdd extends Component {
  static propTypes = {
    ...propTypes
  }

  constructor(props) {
    super(props)

    this.handleSaveDivision = this.handleSaveDivision.bind(this)
    this.handleValueChange = this.handleValueChange.bind(this)
  }

  handleSaveDivision(e) {
    e.preventDefault()
    const { name, dobStart, dobEnd, seasonId, offerGenderDivisionOptions, dispatch, onDivisionSave, men, women } = this.props
    const offerGenderOptions = offerGenderDivisionOptions === 'Y' ? true : false;
    const description = (men && women) ? `${name} (Boys, Girls)` : (men ? `${name} (Boys)` : `${name} (Girls)`);
    const division = {
      name,
      dobStart,
      dobEnd,
      seasonId,
      offerGenderOptions,
      girls: women,
      boys: men,
      description,
    }
    dispatch(addingSeasonDivision())
    dispatch(addSeasonDivision(seasonId, division))
    onDivisionSave()
  }

  handleValueChange() {
    const { dispatch } = this.props
    dispatch(change(formName, 'datasaved', false))
    dispatch(change(formName, 'firstTimeLoad', true))
  }

  render() {
    const {
      datasaved,
      syncErrors,
      addingseasondivision,
      pristine,
      onDivisionCancel,
      men,
      women
    } = this.props;

    const errors = Object.values(syncErrors);

    return (
      <Panel style={styles.divisions.panel}>
        <Row className="center-block center-text">
          <form name='divisionAdd' className="form-horizontal" sm={12}>
            <Col sm={15}>
              {(!pristine) && (errors.length > 0) && <ErrorList errors={errors} />}
              <FormGroup>
                <label className={style.lblattrs}>Name</label>
                <Col sm={6}>
                  <Field
                    type='text'
                    name='name'
                    component='input'
                    onChange={this.handleValueChange}
                    className="form-control no-spinners"
                    style={{ maxwidth: '150px' }}
                  />
                </Col>
              </FormGroup >
              <Field
                label='DOB Start'
                labelattrs={style.lblattrs}
                inputattrs={style.inputattrs6}
                title='DOB Start'
                name='dobStart'
                component={renderDatePickerField}
                placeholder='mm-dd-yyyy'
                onChange={this.handleValueChange}
              />
              <Field
                label='DOB End'
                labelattrs={style.lblattrs}
                inputattrs={style.inputattrs6}
                title='dobEnd'
                name='dobEnd'
                component={renderDatePickerField}
                placeholder='mm-dd-yyyy'
                onChange={this.handleValueChange}
              />
              <FormGroup>
                <label className="col-sm-3 col-md-3 col-lg-3 control-label" style={{ paddingleft: '80px', margintop: '0', marginbottom: '0', paddingtop: '7px' }}>Gender</label>
                <Field
                  key={61}
                  inputattrs={style.inputattrs1}
                  name='men'
                  label='Boys'
                  checked={men}
                  value={men}
                  maxWidth='70px'
                  component={renderCheckboxField}
                  onChange={this.handleValueChange}
                />
                <Field
                  key={62}
                  inputattrs={style.inputattrs1}
                  name='women'
                  label='Girls'
                  checked={women}
                  value={women}
                  maxWidth='70px'
                  component={renderCheckboxField}
                  onChange={this.handleValueChange}
                /></FormGroup>

              <FormGroup>
                <Col lgOffset={2} lg={12}>
                  <button type="button" className="btn btn-default" onClick={this.handleSaveDivision} style={{ marginRight: '10px', color: 'green' }} disabled={pristine || (errors.length > 0)} >
                    <i className={addingseasondivision === true ? 'fa fa-spinner fa-spin' : "fa fa-cogs"} aria-hidden="true" /> &nbsp;&nbsp;Save Division
                  </button>
                  <button type="button" className="btn btn-default" onClick={onDivisionCancel} style={{ marginRight: '10px', color: 'red' }}>
                    <i className="fa fa-remove" aria-hidden="true" /> &nbsp;&nbsp;Cancel
                  </button>

                  {
                    datasaved && (<InfoSaved section='Divisions' />)
                  }
                </Col>
              </FormGroup>
            </Col>
          </form>
        </Row>
      </Panel>)
  }
}

DivisionsAdd.propTypes = {
  initialize: PropTypes.func,
  pristine: PropTypes.bool,
  onDivisionSave: PropTypes.func,
  onDivisionCancel: PropTypes.func,
  addSeasonDivision: PropTypes.func,
  addingSeasonDivision: PropTypes.func,
  settingsseason: PropTypes.string,
  syncErrors: PropTypes.object,
  dispatch: PropTypes.func,
  settingsSaved: PropTypes.func,
  datasaved: PropTypes.bool,
  divisions: PropTypes.object,
  seasonyears: PropTypes.string,
  name: PropTypes.string,
  dobStart: PropTypes.string,
  dobEnd: PropTypes.string,
  men: PropTypes.bool,
  women: PropTypes.bool,
  offerGenderDivisionOptions: PropTypes.string,
  seasonId: PropTypes.string,
  first: PropTypes.bool,
  addingseasondivision: PropTypes.bool,
  newdivisionsaved: PropTypes.bool,
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    addSeasonDivision,
    addingSeasonDivision,
  }, dispatch)
}

function mapStateToProps(state, ownProps) {
  const formName = ownProps.form
  const selector = formValueSelector(formName)
  const syncErrors = getFormSyncErrors(formName)(state)
  const name = selector(state, 'name')
  const addingseasondivision = selector(state, 'addingseasondivision')
  const dobStart = selector(state, 'dobStart')
  const dobEnd = selector(state, 'dobEnd')
  const men = selector(state, 'men')
  const women = selector(state, 'women')
  const offerGenderDivisionOptions = selector(state, 'offerGenderDivisionOptions')
  return {
    formName,
    syncErrors,
    addingseasondivision,
    name,
    dobStart,
    dobEnd,
    men,
    women,
    offerGenderDivisionOptions
  }
}

function validate(values) {
  const errors = []
  const { name, dobStart, dobEnd, isSeasonSet, men, women } = values

  let errorCounter = 0
  if (isSeasonSet) {
    if (!name) {
      errors[errorCounter++] = 'Name is required'
    }
    if (!dobStart) {
      errors[errorCounter++] = 'DOB Start is required'
    }
    if (!dobEnd) {
      errors[errorCounter++] = 'DOB End is required'
    }
    // Other validations
    if (dobStart && dobEnd && (moment(dobStart) > moment(dobEnd))) {
      errors[errorCounter++] = 'DOB start date cannot be later than DOB end date'
    }
    if (!men && !women) {
      errors[errorCounter++] = 'Gender is required'
    }
  }
  else {
    errors[errorCounter++] = "Initiate the season by clicking 'Setup season' in the Season Dates tab"
  }
  return errors
}

export default reduxForm({
  validate,
  form: formName,
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: false,
  initialValues: defaultformstate,
  enableReinitialize: true
})(connect(mapStateToProps, mapDispatchToProps)(DivisionsAdd));




// WEBPACK FOOTER //
// ./src/containers/season/components/DivisionsAdd.js